module.exports = __webpack_public_path__ + "static/bannerImage-73aeb614e29a33f47dd19b5cc161086b.png";